import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface BibliographyLendCount {
  id: number
  collectionNo: string
  status: SystemCode
  holdingBranchCode: SystemCode
  lendTotalCount: number
  lendCount0: number
  lendCount1: number
  lendCount2: number
  lendCount3: number
  lendCount4: number
  lendCount5: number
  revision: number
}

export function BibliographyLendCountFromJSON(
  json: any
): BibliographyLendCount {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    lendTotalCount: exists(json, 'lend_total_count')
      ? json.lend_total_count
      : '',
    lendCount0: exists(json, 'lend_count_0') ? json.lend_count_0 : '',
    lendCount1: exists(json, 'lend_count_1') ? json.lend_count_1 : '',
    lendCount2: exists(json, 'lend_count_2') ? json.lend_count_2 : '',
    lendCount3: exists(json, 'lend_count_3') ? json.lend_count_3 : '',
    lendCount4: exists(json, 'lend_count_4') ? json.lend_count_4 : '',
    lendCount5: exists(json, 'lend_count_5') ? json.lend_count_5 : '',
    revision: exists(json, 'revision') ? json.revision : ''
  }
}
